<template>
	<div class="not-found-page">
		This page is not available
	</div>
</template>

<script>
export default {
	name: 'NotFound',
}
</script>

<style lang="scss">
.not-found-page {
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
